import React, { useState, useEffect } from 'react'; // Import useEffect
import {
  Box,
  Typography,
  ButtonGroup,
} from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom'; // Import useNavigate
import { StyledButton } from './Communication.styles';
import { useParams } from 'react-router-dom';

const Communication: React.FC = () => {
  const [emailList, setEmailList] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [isEmailConfigured, setIsEmailConfigured] = useState<boolean>(false);
  const { tenant } = useParams<{ tenant: string }>();
  const [selectedOption, setSelectedOption] = useState<"email-templates" | "dashboard-messages">("dashboard-messages");

  const navigate = useNavigate(); // Initialize navigate

  const handleSave = () => {
    if (emailList && message) {
      console.log('Message saved:', message);
      setIsEmailConfigured(true); // Show UserListTable after saving
    }
  };

  const handleNavigation = (path: string) => {
    navigate(path); // Navigate to the specified path
  };

  useEffect(() => {

    // Set selectedOption based on current location path
    const path = location.pathname.split("/").pop();
    if (path && path !== selectedOption) {
      setSelectedOption(path as "email-templates" | "dashboard-messages");
    }

    // If location path does not match any of the communication routes, navigate to "email-templates"
    if (
      location.pathname === 'dashboard-messages' ||
      !['email-templates'].some(route => location.pathname.includes(route))
    ) {
      handleNavigation("dashboard-messages");
      setSelectedOption("dashboard-messages");
    }
    else {
      handleNavigation('email-templates');
      setSelectedOption('email-templates');
    }
  }, [location.pathname, selectedOption]);



  return (
    <Box sx={{
      marginLeft: '2.3vw',
      marginRight: '1.3vw',
    }}>
      {/* Header and Actions */}
      <Box display="flex" justifyContent="space-between" gap={5} alignItems="center" sx={{ mb: 1.2 }}>
        <Typography gutterBottom variant="h5">Communication</Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" sx={{ maxWidth: '30vw' }}>
        <ButtonGroup variant="outlined" aria-label="combined button group" sx={{ width: '100%' }}>
          <StyledButton
            variant="outlined"
            onClick={() => handleNavigation(`/${tenant}/Communication/dashboard-messages`)}
            sx={{
              mr: 0.13,
              flexGrow: 1, // Ensures equal space for each button
            }}
            isselected={selectedOption === 'dashboard-messages'} // Pass selected state
          >
            Dashboard Messages
          </StyledButton>

          <StyledButton
            variant="outlined"
            onClick={() => handleNavigation(`/${tenant}/Communication/email-templates`)}
            sx={{
              flexGrow: 1, // Ensures equal space for each button
            }}
            isselected={selectedOption === 'email-templates'} // Pass selected state
          >
            Email Templates
          </StyledButton>
        </ButtonGroup>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: '100%', mb: '1.6vw' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Communication;
